import React from 'react';

import { cn } from '~/utils/cnTailwind';

type Props = {
    className?: string;
    children: React.ReactNode;
    onClick?: () => void;
    onMouseEnter?: (e: React.MouseEvent<HTMLTableDataCellElement>) => void;
    onMouseLeave?: () => void;
};

export const OfferManagementTableData: React.FC<Props> = ({
    children,
    className,
    onClick,
    onMouseEnter,
    onMouseLeave,
}) => {
    return (
        <td
            className={cn('text-xs text-center text-grey whitespace-nowrap p-1', className && className)}
            onMouseEnter={onMouseEnter}
            onClick={onClick}
            onMouseLeave={onMouseLeave}
        >
            {children}
        </td>
    );
};
